//#region IMPORT
import React, { useEffect, useState, useRef } from 'react';
import M_TBG_CUSTOM_03 from './M_TBG_CUSTOM_03';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
// useBackStack 임포트
import { useBackStack } from '../../../../Hooks/back/useBackStack';
import { useSearch1, useSave1 } from './M_TBG_CUSTOM_03_Query';
import { useSave } from '../../../../Hooks/useSave';
//#endregion

function M_TBG_CUSTOM_03F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const activeStep = useSelector((state) => state.common.activeStep);

  // 최신 activeStep 참조용 ref
  const activeStepRef = useRef(activeStep);
  useEffect(() => {
    activeStepRef.current = activeStep;
  }, [activeStep]);

  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    type: 'info',
  });
  const [fullUrl, setFullUrl] = useState();
  const [renderPreview, setRenderPreview] = useState(null);
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [pageWidth, setPageWidth] = useState(window.innerWidth * 1);
  const [pageViewHeight, setPageViewHeight] = useState(0);
  //#endregion

  // 뒤로가기 핸들러: useBackStack 적용
  useBackStack({
    type: 'custom',
    onBack: () => {
      // 1. 데이터 저장 (Step 1로 롤백)
      // Save1([{ eStep: '1', mStep: '0', tbmCd: props.tbmCdRef.current }]);

      // 2. 버튼 상태 설정
      props.ActiveButton({
        type: 'prev',
        content: true,
        step: 1,
      });

      // 3. 단계 이동
      dispatch(CommonActions.setActiveStep(activeStepRef.current - 1));
    },
  });

  //#region 이벤트
  useEffect(() => {
    Init();
    const handleResize = () => {
      setPageWidth(window.innerWidth * 1);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (loading) setLoading(false);
  }, [pageNumber]);

  const Init = async () => {
    // 초기 로직 (필요 시 검색 호출)
    try {
      // 기존 registerBackGuardHandler 로직은 useBackStack으로 이관되었으므로 제거
    } catch (e) {
      console.log(e);
    }
  };
  //#endregion

  //#region 쿼리 (기존 로직 유지)
  const { refetch: Search1 } = useSearch1({
    onSuccess: async (rows) => {
      const first = rows[0];
      const path = first?.eduLocation;
      if (!path) {
        setFullUrl(null);
        setRenderPreview(null);
        return;
      }
      const ext = path.split('.').pop()?.toLowerCase();
      let finalPath = path;
      if (['hwp', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].includes(ext)) {
        finalPath = path.replace(/\.[^/.]+$/, '.pdf');
      }
      const fileUrl = `${Global.file.useUrl}files/${finalPath}`;
      setFullUrl(fileUrl);
      const res = await fetch(fileUrl);
      const blob = await res.blob();
      const base64 = await blobToBase64(blob);
      setRenderPreview(base64);
    },
  });
  const { runAsync: Save1Async } = useSave1();
  const { run: Save1 } = useSave({
    menuId: 'M_TBG_CUSTOM_03',
    requestSave: (rows) => Save1Async(rows),
  });
  //#endregion

  //#region 나머지 함수
  const getExtensionFromUrl = (url = '') => {
    const parts = url?.split('.');
    return parts?.length > 1 ? parts.pop().toLowerCase() : '';
  };
  const onDocumentLoadSuccess = ({ numPages: total }) => setNumPages(total);
  const goToPrevPage = () => {
    if (pageNumber > 1) {
      setLoading(true);
      setPageNumber(pageNumber - 1);
    } else {
      dispatch(CommonActions.setActiveStep(activeStepRef.current - 1));
    }
  };
  const goToNextPage = () => {
    if (pageNumber < numPages) {
      setLoading(true);
      setPageNumber(pageNumber + 1);
    }
  };
  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };
  //#endregion

  return (
    <M_TBG_CUSTOM_03
      userInfo={userInfo}
      loading={loading}
      setLoading={setLoading}
      onDocumentLoadSuccess={onDocumentLoadSuccess}
      pageNumber={pageNumber}
      pageWidth={pageWidth}
      numPages={numPages}
      activeStep={activeStep}
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      pageViewHeight={pageViewHeight}
      setPageViewHeight={setPageViewHeight}
      renderPreview={renderPreview}
      goToPrevPage={goToPrevPage}
      goToNextPage={goToNextPage}
      ActiveButton={props.ActiveButton}
      fullUrl={fullUrl}
      getExtensionFromUrl={getExtensionFromUrl}
    />
  );
}

export default M_TBG_CUSTOM_03F;
